module.exports = __webpack_public_path__ + "img/礼生.bf642bbb.png";